import { inject, Injectable } from '@angular/core';
import { apiUrls } from '../../../common/api_urls/api_urls';
import { catchError, tap, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { headers } from '../../../common/headers';

const header = new HttpHeaders({ [headers.lookupHeader]: 'true' });

@Injectable({
  providedIn: 'root',
})
export class SetPasswordService {
  public http = inject(HttpClient);
  public authService = inject(AuthService);
  public cookieService = inject(CookieService);

  constructor() {}
  setPassword(data: any) {
    var bodyData = {
      username: data.email,
      newPassword: data.password,
      session: this.authService.getSession(
        this.authService.setPasswordSessionKey,
      ),
    };
    return this.http
      .post(apiUrls.authentication.setPasword, bodyData, { headers: header })
      .pipe(
        tap((data: any) => {
          this.cookieService.deleteAll();
          this.authService.saveSessionByKey(
            this.authService.emailKey,
            bodyData.username,
          );
          this.authService.saveSession(data?.accessToken);
          this.authService.saveRefreshSession(data?.refreshToken);
          this.authService.deleteSession(
            this.authService.setPasswordSessionKey,
          );
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }
}
